
<template>
    <div class="w-full flex justify-center">
      <!-- inicio de contenido -->
      <div
        class="w-full bg-white mt-5 sm:mt-10 md:ml-20 md:mr-20"      
      >
          <!--New Design-->
          <div class="mb-4 border-b border-gray-200 dark:border-gray-700">
            <ul class="flex flex-wrap -mb-px text-sm font-medium text-center" role="tablist">
              <li class="me-2" role="presentation">
                <button
                  :class="['inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg', activeTab === 'profile' ? 'text-tuin-100 border-tuin-100' : 'text-gray-500 border-gray-100']"
                  @click="activeTab = 'profile'"
                  type="button"
                  role="tab"
                > 
                  <svg class="w-4 h-4 me-2" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                    <path d="M13.3333 5.02632H11.3333V4.39474C11.3333 3.89222 11.1226 3.41029 10.7475 3.05496C10.3725 2.69962 9.86375 2.5 9.33331 2.5H6.66665C6.13621 2.5 5.62751 2.69962 5.25243 3.05496C4.87736 3.41029 4.66665 3.89222 4.66665 4.39474V5.02632H2.66665C2.31302 5.02632 1.97389 5.1594 1.72384 5.39629C1.47379 5.63317 1.33331 5.95446 1.33331 6.28947V13.2368C1.33331 13.5719 1.47379 13.8931 1.72384 14.13C1.97389 14.3669 2.31302 14.5 2.66665 14.5H13.3333C13.6869 14.5 14.0261 14.3669 14.2761 14.13C14.5262 13.8931 14.6666 13.5719 14.6666 13.2368V6.28947C14.6666 5.95446 14.5262 5.63317 14.2761 5.39629C14.0261 5.1594 13.6869 5.02632 13.3333 5.02632ZM5.99998 4.39474C5.99998 4.22723 6.07022 4.06659 6.19524 3.94814C6.32027 3.8297 6.48983 3.76316 6.66665 3.76316H9.33331C9.51012 3.76316 9.67969 3.8297 9.80472 3.94814C9.92974 4.06659 9.99998 4.22723 9.99998 4.39474V5.02632H5.99998V4.39474ZM13.3333 6.28947V8.52779C10.8526 10.6082 5.14731 10.6082 2.66665 8.52779V6.28947H13.3333ZM2.66665 13.2368V10.0827C4.29848 10.9332 6.13791 11.3617 7.99998 11.3251C9.86203 11.3616 11.7014 10.9331 13.3333 10.0827V13.2368H2.66665Z" fill="currentColor"/>
                    <path d="M7.99998 8.81579C8.36817 8.81579 8.66665 8.53302 8.66665 8.18421C8.66665 7.8354 8.36817 7.55263 7.99998 7.55263C7.63179 7.55263 7.33331 7.8354 7.33331 8.18421C7.33331 8.53302 7.63179 8.81579 7.99998 8.81579Z" fill="#FF4265"/>
                  </svg>Datos de la <br class="block md:hidden">inmobiliaria
                </button>
              </li>
              <li class="me-2" role="presentation">
                <button
                  :class="['inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg', activeTab === 'address' ? 'text-tuin-100 border-tuin-100' : 'text-gray-500 border-gray-100']"
                  @click="activeTab = 'address'"
                  type="button"
                  role="tab"
                >
                  <svg class="w-4 h-4 me-2 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="currentColor">
                    <path d="M8.00048 9.83275C7.47306 9.83275 6.95749 9.67635 6.51896 9.38333C6.08043 9.09031 5.73863 8.67384 5.5368 8.18657C5.33496 7.6993 5.28216 7.16312 5.38505 6.64584C5.48794 6.12856 5.74192 5.6534 6.11486 5.28046C6.4878 4.90752 6.96295 4.65355 7.48024 4.55065C7.99752 4.44776 8.5337 4.50057 9.02097 4.7024C9.50824 4.90423 9.92471 5.24603 10.2177 5.68456C10.5107 6.12309 10.6671 6.63866 10.6671 7.16608C10.6671 7.87332 10.3862 8.5516 9.8861 9.0517C9.386 9.55179 8.70772 9.83275 8.00048 9.83275ZM8.00048 5.83275C7.73677 5.83275 7.47898 5.91094 7.25972 6.05745C7.04045 6.20396 6.86955 6.4122 6.76864 6.65583C6.66772 6.89947 6.64132 7.16756 6.69276 7.4262C6.74421 7.68484 6.8712 7.92242 7.05767 8.10889C7.24414 8.29536 7.48172 8.42235 7.74036 8.47379C7.999 8.52524 8.26709 8.49884 8.51072 8.39792C8.75436 8.297 8.96259 8.12611 9.1091 7.90684C9.25561 7.68757 9.33381 7.42979 9.33381 7.16608C9.33381 6.81246 9.19333 6.47332 8.94329 6.22327C8.69324 5.97322 8.3541 5.83275 8.00048 5.83275Z" fill="currentColor"/>
                    <path d="M8.00048 15.1661C7.90205 15.166 7.80485 15.1442 7.71586 15.1021C7.62688 15.06 7.54831 14.9988 7.48581 14.9227L3.98914 10.6734C3.92248 10.5987 3.84648 10.5054 3.77181 10.4067L3.69181 10.3094C3.66076 10.2718 3.63393 10.2309 3.61181 10.1874C3.0627 9.39119 2.74044 8.46064 2.67953 7.49535C2.61863 6.53006 2.82136 5.56638 3.26605 4.70746C3.71073 3.84854 4.38061 3.12671 5.204 2.61923C6.02738 2.11176 6.97327 1.83775 7.94041 1.82653C8.90756 1.81531 9.85955 2.06731 10.6945 2.55554C11.5294 3.04377 12.2159 3.74987 12.6804 4.59825C13.1448 5.44662 13.3699 6.40534 13.3314 7.37178C13.2929 8.33822 12.9923 9.276 12.4618 10.0847C12.44 10.1306 12.4127 10.1736 12.3805 10.2127L12.2958 10.3161C12.1766 10.4791 12.048 10.6349 11.9105 10.7827L8.51581 14.9194C8.45356 14.9961 8.37503 15.0581 8.28591 15.1007C8.19678 15.1434 8.09929 15.1657 8.00048 15.1661ZM4.78381 9.54075L4.81514 9.57875C4.88181 9.66875 4.94381 9.74008 5.00514 9.80941L8.00048 13.4494L10.9058 9.91075C11.0252 9.78218 11.1365 9.64637 11.2391 9.50408L11.2891 9.44341L11.3065 9.41608C11.7188 8.81145 11.9574 8.10527 11.9962 7.37444C12.035 6.6436 11.8726 5.91613 11.5266 5.27123C11.1806 4.62632 10.6643 4.0887 10.0339 3.71691C9.4035 3.34512 8.68319 3.1534 7.95138 3.16264C7.21958 3.17187 6.50433 3.3817 5.88352 3.76928C5.26272 4.15686 4.76014 4.70734 4.43052 5.36077C4.1009 6.0142 3.95686 6.74554 4.0141 7.47516C4.07134 8.20478 4.32766 8.90471 4.75514 9.49875C4.76581 9.51297 4.77537 9.52697 4.78381 9.54075Z" fill="currentColor"/>
                  </svg>Dirección y <br class="block md:hidden">Ubicación
                </button>
              </li>
              <li class="me-2" role="presentation">
                <button
                  :class="['inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg', activeTab === 'networks' ? 'text-tuin-100 border-tuin-100' : 'text-gray-500 border-gray-100']"
                  @click="activeTab = 'networks'"
                  type="button"
                  role="tab"
                >
                  <svg class="w-4 h-4 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="currentColor">
                    <path d="M14.5 7.57348C14.4979 7.01671 14.3108 6.47631 13.968 6.03678C13.6252 5.59725 13.146 5.28335 12.6053 5.14416V3.75886C12.6052 3.52754 12.5412 3.30072 12.4203 3.10327C12.2994 2.90582 12.1263 2.74538 11.92 2.63955C11.7137 2.53371 11.4822 2.48657 11.2508 2.5033C11.0194 2.52002 10.797 2.59997 10.6082 2.73436L7.35053 5.05475H3.76316C3.42815 5.05475 3.10686 5.18743 2.86997 5.42361C2.63308 5.65979 2.5 5.98011 2.5 6.31412V8.83285C2.5 9.16685 2.63308 9.48718 2.86997 9.72336C3.10686 9.95953 3.42815 10.0922 3.76316 10.0922V13.2406C3.76316 13.5746 3.89624 13.895 4.13313 14.1311C4.37002 14.3673 4.69131 14.5 5.02632 14.5H5.65789C5.9929 14.5 6.31419 14.3673 6.55108 14.1311C6.78797 13.895 6.92105 13.5746 6.92105 13.2406V10.0922H7.35053L10.6076 12.412C10.7964 12.5465 11.0188 12.6266 11.2503 12.6435C11.4818 12.6603 11.7135 12.6132 11.9199 12.5073C12.1263 12.4015 12.2995 12.2409 12.4204 12.0434C12.5413 11.8458 12.6053 11.6189 12.6053 11.3875V10.0022C13.1459 9.86301 13.625 9.54921 13.9678 9.1098C14.3106 8.6704 14.4978 8.13015 14.5 7.57348ZM3.76316 6.31412H6.92105V8.83285H3.76316V6.31412ZM5.65789 13.2406H5.02632V10.0922H5.65789V13.2406ZM11.3421 11.3875L8.18421 9.13825V6.00809L11.3421 3.75571V11.3875ZM12.6053 8.66346V6.4835C12.797 6.59412 12.9561 6.75306 13.0668 6.94437C13.1774 7.13568 13.2357 7.35264 13.2357 7.57348C13.2357 7.79432 13.1774 8.01128 13.0668 8.20259C12.9561 8.3939 12.797 8.55284 12.6053 8.66346Z" fill="currentColor"/>
                  </svg>Redes <br class="block md:hidden">Sociales
                </button>
              </li>
            </ul>
          </div>
          <div>
            <div v-show="activeTab === 'profile'">
              <FormCompaComponent
                  :property-id="id"
                  @trigger-update-property="updateProperty"
                />
            </div>
            <div v-show="activeTab === 'networks'">
              <FormNetworksComponentCompany
              />
            </div>
            <div v-show="activeTab === 'address'">
              <FormLocationComponent
                  :resp="data_company"
                  :property-id="id"
                  Type="company" 
                />
            </div>
          </div>
      </div>
    </div>
  </template>
  <script setup>
  
 /* import {
    FwbTab,
    FwbTabs,
  } from "flowbite-vue";*/
  import { ref, onMounted, watch, computed } from "vue";
  import { useRoute } from "vue-router";
  import FormLocationComponent from "./FormLocationComponent.vue";
  import { useStore } from "vuex";
  import axios from "axios";
  import FormNetworksComponentCompany from "./FormNetworksComponentCompany.vue";
  import FormCompaComponent from "./FormCompaComponent.vue";
  const store = useStore();
  let session = computed(() => store.getters.getUserSession);
  // Acceder al parámetro 'id' de la URL directamente
  const route = useRoute();
  let id = session.value.id;
  let active_tab = ref(true);
 const activeTab = ref("profile");
  let step = ref(3);
  let data_company = ref({});
  const hasSlug = ref(false); 
  
  onMounted(async () => {
    console.log('[ID PROPIEDAD]',id)
    if (id != undefined) {
      active_tab.value = true;
    }
  });
  
  async function getInfoCompany(){
  
    let options = {
        headers: {
        Authorization: `Bearer ${session.value.token_api}`,
        },
    };

    let link_api = `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${session.value.id}/company`;
    const response = await axios.get(
        link_api,
        options
        );
    try {
        if (response.status == 401) {
        store.dispatch("clearUserSession");
        }

        if (response.status == 200) {
            console.log(response)
            data_company.value = response;
            
            step.value = 2;
        
        }
    } catch (error) {
        console.error("Error fetching data:", error);
    }
    }
  
  async function updateProperty(property_id){
    console.log('actualiza estado de tabs', property_id)
    active_tab.value = true;
  }
  onMounted(async () => {
      try {
        await getInfoCompany();
        // Modificamos la ruta para acceder correctamente al slug
        hasSlug.value = data_company.value?.data?.resp?.info?.slug ? true : false;
        step.value = session.value.step;
      } catch (error) {
        console.error("Error al intentar traer los datos", error);
      }
  });
  watch(activeTab, async (newTab) => {
    if (newTab === 'first') {
      await getInfoCompany(); // Al seleccionar "Datos generales", cargamos los datos de la compañía
    }
  });
  watch(
    () => route.params.id,
    (newId) => {
      console.log('[-----]',newId)
        id =  newId
    }
  );
  
  </script>